import RateTable from './RateTable';

export default RateTable;
